import { render, staticRenderFns } from "./ProcessTemplateResults.vue?vue&type=template&id=0cf9d15f&scoped=true&"
import script from "./ProcessTemplateResults.vue?vue&type=script&lang=js&"
export * from "./ProcessTemplateResults.vue?vue&type=script&lang=js&"
import style0 from "./ProcessTemplateResults.vue?vue&type=style&index=0&id=0cf9d15f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9d15f",
  null
  
)

export default component.exports